module.exports = __webpack_public_path__ + "static/media/logo-city-frase-reg-branco.043a4c16.png";